.linkIcon {
  margin-left: auto;
  @include rotate-fourty-five;
}
